import React from "react";

import { withStyles } from '@material-ui/core/styles';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';

import IconButton from '@material-ui/core/IconButton';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { ZonicModel } from '../../../Models'

import styles from "./ModelInfoPopup.module.css";

const AccordionSummary  = withStyles({
  content: {
    margin: "0 !important",
  },
  summary: {
    margin: "0 !important",
  },
  expanded: {minHeight:'0px !important'},
})(MuiAccordionSummary);


export default function ModelInfo(props: {model:ZonicModel | null}) {

  const {model} = props;
  
  const [showInfo, setShowInfo] = React.useState(false);
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const handleChange = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={styles.InfoContainer}>
        {showInfo ? (
            <div className={styles.Info}>
              <br/>
              <table>
                <tbody>
                  {model?.factName ? (
                    <tr>
                      <td colSpan={2} className={styles.FactName}>{model?.factName}:</td>
                    </tr>
                  ) : null}
                  {Object.keys(model?.facts).map((key) => (
                    <tr key={key}>
                      <td className={styles.FactKey}>{key}:</td>
                      <td className={styles.FactValue}>{model?.facts[key]}</td>
                    </tr>
                  ))}
                  {model?.fact ? (
                    <tr>
                      <td colSpan={2} style={{lineHeight: '42px'}} className={styles.FactName}>{model?.fact}</td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
              {model?.fact ? null : (<br />)}
              <div className={styles.AccordionContainer}>
              {Object.keys(model?.accordionFacts).map((key) => (
                    <Accordion key={key} expanded={expanded === key} onChange={handleChange(key)}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <h3 className={styles.AccordionKey}>{key}</h3>
                      </AccordionSummary>
                      <AccordionDetails>
                        <ul className={styles.AccordionFacts}>
                          {model?.accordionFacts[key].map((fact: string, index: number) => (
                            <li className={styles.FactValue} key={index}>{fact}</li>
                          ))}
                        </ul>
                      </AccordionDetails>
                    </Accordion>
                  ))}

              </div>
            </div>
        ): null}
      <div className={styles.BtnContainer}>
        <div className={'instruction-info-field'}>
          <div className={'instruction-info-back'}>
            <p style={{top:40, right:0, textAlign: 'right'}}>Zusatz-informationen</p>
          </div>
          <IconButton  
            color="inherit"
            onClick={() => {setShowInfo(!showInfo);} }
            >
              {showInfo ? ( <HighlightOffIcon fontSize="large" /> ) : (<InfoOutlinedIcon fontSize="large"/> )}
          </IconButton >
        </div>
      </div>
    </div>
  );
}